<script>
  import Avatar from "./Avatar.svelte";
  import { fly } from "svelte/transition";
  import { onMount } from "svelte";

  let onLoad = false;

  onMount(() => {
    setTimeout(() => (onLoad = true), 50);
  });
</script>

<style>
  .card {
    display: flex;
    justify-content: center;
  }

  .card__data {
    display: flex;
    flex-direction: column;
    justify-content: center;

    padding: var(--d-spacing);
  }

  .card__name {
    font-size: 2em;

    color: var(--c-black);
  }

  .card__subtitle {
    margin-top: var(--d-spacing-half);

    font-size: 1.2em;

    color: var(--c-dark-grey);
  }
</style>

{#if onLoad}
  <div class="card" in:fly={{ y: -50, duration: 2000 }}>
    <Avatar src="./assets/avatar.png" alt="Profile picture of Oğuzhan Yıldız" />
    <div class="card__data">
      <p class="card__name">Oğuzhan Yıldız</p>
      <p class="card__subtitle">Developer & Scrum Master</p>
    </div>
  </div>
{/if}
